export const APIUrl = 'https://smartlogin.realsmart.co.uk';
export const AdminURL = 'https://provision.realsmart.co.uk';
export const LoginUrl = 'https://smartlogin.realsmart.co.uk';
export const LogoutUrl = 'https://provision.realsmart.co.uk/admin/logout';
